import http from "./helpers/httpInterceptor";

const state = () => ({
  specialExplanationList: [],
});

// mutations
const mutations = {
  SPECIAL_EXPLANATION_LIST(states, data) {
    states.specialExplanationList = data;
  },
};

// actions
const actions = {
  getSpecialExplanationData({ commit }, url) {
    return http
      .get("/tms/explanations-special" + url)
      .then((res) => {
        commit("SPECIAL_EXPLANATION_LIST", res.data);
        return res.data;
      })
      .catch((error) => {
        throw error;
      });
  },
  createSpecialExplanation(_, payload) {
    return http
      .post("/tms/explanations-special", payload)
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        throw error;
      });
  },
  updateSpecialExplanation(_, payload) {
    return http
      .put("/tms/explanations-special", payload)
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        throw error;
      });
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
